import TwoColumnLayout from "layout/TwoColumnLayout";
import { useLoaderData } from "react-router";
import React from "react";
import { GroundTransportDetailSection } from "groundTransport/GroundTransportDetailSection";
import GroundTransportOptionsPanel from "groundTransport/GroundTransportOptionsPanel";
import { GroundTransportActivityPanel } from "./activity/GroundTransportActivityPanel";
import { GroundTransportItinerarySidebarApp } from "show/ItinerarySidebar/app";
import moment from "moment";
import { useQuery } from "@tanstack/react-query";

export const GroundTransportDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.GroundTransportDetailFrontModel>();
  const [artist, setArtist] = React.useState<server.dto.ArtistSmall>(viewModel.groundTransport.artist);
  const [appointmentDateTime, setAppointmentDateTime] = React.useState<server.dto.AppointmentDateTime>(viewModel.groundTransport.appointmentDateTime);
  const [queryKey, setQueryKey] = React.useState<number>(0);

  const linkedShowsQuery = useQuery({
    queryKey: ["linkedShowsToFlight", viewModel.groundTransport.groundTransportId],
    queryFn: async () => {
      const result = await window.CoreApi.GroundTransport.GetSidePanelData(viewModel.groundTransport.groundTransportId);
      return result.data.data?.linkedShows ?? [];
    },
    initialData: viewModel.linkedShows,
    initialDataUpdatedAt: Date.now(),
    staleTime: Infinity,
  });

  const linkedShowsData = linkedShowsQuery.data ?? [];

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <GroundTransportDetailSection
        groundTransport={viewModel.groundTransport}
        linkedShows={linkedShowsData}
        travellers={viewModel.travellers}
        onArtistChanged={a => setArtist(a)}
        onStatusChanged={() => setQueryKey(prev => prev + 1)}
        onDateChanged={d => {
          setAppointmentDateTime(d)
          setQueryKey(prev => prev + 1);
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GroundTransportOptionsPanel
        optionsPanelData={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
        groundTransportId={viewModel.groundTransport.groundTransportId}
      />
      {site.currentEnvironment.type === "internal" && <GroundTransportItinerarySidebarApp
        groundTransportId={viewModel.groundTransport.groundTransportId}
        artist={artist}
        startDate={moment.utc(appointmentDateTime.startDisplay)}
        endDate={moment.utc(appointmentDateTime.endDisplay)}
        linkedShowIds={linkedShowsData.map(ls => ls.showId)}
        queryKeys={`groundTransportItinerary-${queryKey}`}
      />}
      {site.currentEnvironment.type === "internal" && <GroundTransportActivityPanel
        config={viewModel.activityPanelConfig}
        groundTransportId={viewModel.groundTransport.groundTransportId}
      />}
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}